import React from "react";
import { TextField, MenuItem, FormControl } from "@mui/material";
import { facebookDropdownStyles } from "../../../styles/textFieldStyles";

const PlanSubscriptionSelectInput = ({
  id,
  label,
  name,
  value = "",
  onChange,
  required,
  helperText,
  options = [],
  disabled = false,
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      disabled={disabled}
      sx={{ mb: { xs: 1.5, sm: 2, md: 2.5 } }}
    >
      <TextField
        id={id}
        name={name}
        select
        label={label}
        value={value}
        onChange={onChange}
        helperText={helperText}
        disabled={disabled}
        fullWidth
        InputProps={{ notched: false }}
        sx={facebookDropdownStyles}
      >
        {options.map((opt, index) => (
          <MenuItem key={index} value={opt.id} sx={{ fontSize: "15px", py: 1.2 }}>
            {`${opt.label} (${opt.value})`}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default PlanSubscriptionSelectInput;